module.exports = __webpack_public_path__ + "img/arrow-right-ffa-90-b.500a9eba.svg";